import { UniAnswer } from "../../dao/UniAnswer";
import { UniForm } from "../../dao/UniForm";
import { UiMetaTable } from "../FrmSpwkQuestV3/UiMetaTable";
import {
  UNKNOWN,
  CommonExportUtil as Util,
  YesNoRule,
} from "./CommonExportUtil";
import { Project } from "../../dao/Project";
import { Member } from "../../dao/Member";
import { F05CacheDAO } from "../../dao/F05CacheDAO";
import { F05Cache } from "../../dao/F05Cache";

export class F05_ExportManager {
  static async Export_F05v0(
    is_save_cache: boolean,
    set_Progress: ((value: React.SetStateAction<number>) => void) | null,
    common_form: UniForm,
    meta_table: UiMetaTable,
    answer_list: UniAnswer[],
    _Project: Project,
    sel_member_list: Member[]
  ): Promise<F05_ExportData[]> {
    let export_list: F05_ExportData[] = [];

    let total = answer_list.length;
    let ii = 0;

    for (const ans of answer_list) {
      ii++;

      let rhf_data = ans.ConvertToCommonRhfData();

      let export_data: F05_ExportData = new F05_ExportData();

      //#region 帶入基本資料
      let sel_ans_member = sel_member_list.find(
        (member) => member.guid === ans.member_guid
      ); //取得該ans的member資料

      export_data.填寫日期 = Util.填寫日期(ans);

      export_data.項次 = Util.項次();

      export_data.廠區 = Util.廠區(_Project);
      export_data.部門代號 = Util.部門代號();
      export_data.部門名稱 = Util.部門名稱(sel_ans_member);

      export_data.工號 = Util.工號(sel_ans_member); //XXX 改以 member 為準 Util.GetString(rhf_data, "m01.基本資訊●工號●input_1");
      export_data.姓名 = Util.姓名(sel_ans_member); //XXX 改以 member 為準 Util.GetString(rhf_data, "m01.基本資訊●姓名●input_1");
      export_data.健檢日期 = Util.健檢日期(sel_ans_member);

      export_data.性別 = Util.性別(ans, sel_ans_member);
      //#endregion

      export_data.工作時數_近6個月期間每月平均加班工時 = Util.OptionValue(
        meta_table,
        rhf_data,
        "m02.近6月_平均工時",
        UNKNOWN,
        null
      );

      let 是否RULE: YesNoRule = {
        true_val: "是",
        false_val: "否",
        unknown_val: "否",
      }; // 由於我們只會紀錄 有無勾選，所以 沒紀錄的視為 "否"

      export_data.Q1_工作型態_不規律的工作 =
        "" +
        Util.GetBool_CheckBox(rhf_data, "m03.工作型態.不規律的工作", 是否RULE);
      export_data.Q2_工作型態_經常出差的工作 =
        "" +
        Util.GetBool_CheckBox(
          rhf_data,
          "m03.工作型態.經常出差的工作",
          是否RULE
        );
      export_data.Q3_工作型態_異常溫度環境 =
        "" +
        Util.GetBool_CheckBox(rhf_data, "m03.工作型態.異常溫度環境", 是否RULE);
      export_data.Q4_工作型態_作業環境有噪音 =
        "" +
        Util.GetBool_CheckBox(
          rhf_data,
          "m03.工作型態.作業環境有噪音",
          是否RULE
        );
      export_data.Q5_工作型態_伴隨精神緊張的工作 =
        "" +
        Util.GetBool_CheckBox(
          rhf_data,
          "m03.工作型態.伴隨精神緊張的工作",
          是否RULE
        );
      export_data.Q6_工作型態_作業環境有時差 =
        "" +
        Util.GetBool_CheckBox(
          rhf_data,
          "m03.工作型態.作業環境有時差",
          是否RULE
        );

      [
        export_data.Q1_工作型態_不規律的工作,
        export_data.Q2_工作型態_經常出差的工作,
        export_data.Q3_工作型態_異常溫度環境,
        export_data.Q4_工作型態_作業環境有噪音,
        export_data.Q5_工作型態_伴隨精神緊張的工作,
        export_data.Q6_工作型態_作業環境有時差,
      ].some((x) => x === "是");
      export_data.工作型態_工作型態以下選項是否有符合 = [
        export_data.Q1_工作型態_不規律的工作,
        export_data.Q2_工作型態_經常出差的工作,
        export_data.Q3_工作型態_異常溫度環境,
        export_data.Q4_工作型態_作業環境有噪音,
        export_data.Q5_工作型態_伴隨精神緊張的工作,
        export_data.Q6_工作型態_作業環境有時差,
      ].some((x) => x === "是")
        ? "是"
        : "否";

      export_list.push(export_data);

      //#region 匯出時同時保存快取

      if (is_save_cache) {
        // 撈出舊資料
        let cache_data = await F05CacheDAO.FetchByMemberGuid(ans.member_guid);

        // 如果有則刪除
        if (cache_data != null) {
          await F05CacheDAO.Delete(cache_data);
        }

        // 重新新增
        cache_data = F05Cache.new_F05Cache(ans.member_guid, export_data);
        await F05CacheDAO.Insert(cache_data);
      }

      if (set_Progress != null) {
        const rate = (ii * 100.0) / total;
        set_Progress(rate);
      }

      //#endregion
    }

    return export_list;
  }
}

export class F05_ExportData {
  填寫日期 = "";

  項次 = "";

  廠區 = "";
  部門代號 = "";
  部門名稱 = "";

  工號 = "";
  姓名 = "";
  健檢日期 = "";

  性別 = "";

  //--------------------

  工作時數_近6個月期間每月平均加班工時 = "";
  工作型態_工作型態以下選項是否有符合 = "";
  Q1_工作型態_不規律的工作 = "";
  Q2_工作型態_經常出差的工作 = "";
  Q3_工作型態_異常溫度環境 = "";
  Q4_工作型態_作業環境有噪音 = "";
  Q5_工作型態_伴隨精神緊張的工作 = "";
  Q6_工作型態_作業環境有時差 = "";
}
